import clienteAxios from "../config/axios";

export async function getConceptosByTDoc(tDocCodFor, tDocNroFor) {
  return clienteAxios.get(`/concepto/${tDocCodFor}/${tDocNroFor}`);
}

export async function getLastMappings(nroCta) {
  return clienteAxios.get(`/concepto/lastMappings/${nroCta}`);
}
